"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToDeposits = exports.submittingDeposit = exports.requestDepositTickets = exports.receiveDepositTickets = exports.receiveDepositTicket = exports.receiveDepositTemplates = exports.receiveDepositTemplate = exports.receiveDepositInfo = exports.getDepositTickets = exports.getDepositInfo = exports.fetchingDepositTemplates = exports.fetchingDepositTemplate = exports.fetchingDepositInfo = exports.fetchProductDepositTemplate = exports.fetchAllProductDepositTemplates = exports.depositTemplatesError = exports.depositTemplateError = exports.depositInfoError = exports.createDepositTicket = exports.addDeposit = exports.SUBMITTING_DEPOSIT = exports.RETAIL_FIAT_CONFIRM_DEPOSIT = exports.RESET_DEPOSIT_INFO = exports.REQUEST_DEPOSIT_TICKETS = exports.RECEIVE_DEPOSIT_TICKETS = exports.RECEIVE_DEPOSIT_TICKET = exports.RECEIVE_DEPOSIT_TEMPLATE_ERROR = exports.RECEIVE_DEPOSIT_TEMPLATES_ERROR = exports.RECEIVE_DEPOSIT_TEMPLATES = exports.RECEIVE_DEPOSIT_TEMPLATE = exports.RECEIVE_DEPOSIT_INFO_ERROR = exports.RECEIVE_DEPOSIT_INFO = exports.FETCH_PRODUCT_DEPOSIT_TEMPLATES = exports.FETCH_PRODUCT_DEPOSIT_TEMPLATE = exports.FETCH_DEPOSIT_INFO = exports.ADD_DEPOSIT = void 0;
var _apiActions = require("./apiActions");
var _depositSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/depositSubscriptionService"));
var _snackbarActions = require("./snackbarActions");
var _sidePaneActions = require("./sidePaneActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _config = _interopRequireDefault(require("../../config"));
var _excluded = ["ProductId", "amount"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var FETCH_PRODUCT_DEPOSIT_TEMPLATES = exports.FETCH_PRODUCT_DEPOSIT_TEMPLATES = 'FETCH_PRODUCT_DEPOSIT_TEMPLATES';
var FETCH_PRODUCT_DEPOSIT_TEMPLATE = exports.FETCH_PRODUCT_DEPOSIT_TEMPLATE = 'FETCH_PRODUCT_DEPOSIT_TEMPLATE';
var RECEIVE_DEPOSIT_TEMPLATES = exports.RECEIVE_DEPOSIT_TEMPLATES = 'RECEIVE_DEPOSIT_TEMPLATES';
var RECEIVE_DEPOSIT_TEMPLATES_ERROR = exports.RECEIVE_DEPOSIT_TEMPLATES_ERROR = 'RECEIVE_DEPOSIT_TEMPLATES_ERROR';
var RECEIVE_DEPOSIT_TEMPLATE = exports.RECEIVE_DEPOSIT_TEMPLATE = 'RECEIVE_DEPOSIT_TEMPLATE';
var RECEIVE_DEPOSIT_TEMPLATE_ERROR = exports.RECEIVE_DEPOSIT_TEMPLATE_ERROR = 'RECEIVE_DEPOSIT_TEMPLATE_ERROR';
var RECEIVE_DEPOSIT_INFO_ERROR = exports.RECEIVE_DEPOSIT_INFO_ERROR = 'RECEIVE_DEPOSIT_INFO_ERROR';
var SUBMITTING_DEPOSIT = exports.SUBMITTING_DEPOSIT = 'SUBMITTING_DEPOSIT';
var FETCH_DEPOSIT_INFO = exports.FETCH_DEPOSIT_INFO = 'FETCH_DEPOSIT_INFO';
var RECEIVE_DEPOSIT_INFO = exports.RECEIVE_DEPOSIT_INFO = 'RECEIVE_DEPOSIT_INFO';
var RECEIVE_DEPOSIT_TICKET = exports.RECEIVE_DEPOSIT_TICKET = 'RECEIVE_DEPOSIT_TICKET';
var RECEIVE_DEPOSIT_TICKETS = exports.RECEIVE_DEPOSIT_TICKETS = 'RECEIVE_DEPOSIT_TICKETS';
var RESET_DEPOSIT_INFO = exports.RESET_DEPOSIT_INFO = 'RESET_DEPOSIT_INFO';
var RETAIL_FIAT_CONFIRM_DEPOSIT = exports.RETAIL_FIAT_CONFIRM_DEPOSIT = 'RETAIL_FIAT_CONFIRM_DEPOSIT';
var ADD_DEPOSIT = exports.ADD_DEPOSIT = 'ADD_DEPOSIT';
var REQUEST_DEPOSIT_TICKETS = exports.REQUEST_DEPOSIT_TICKETS = 'REQUEST_DEPOSIT_TICKETS';
var fetchAllProductDepositTemplates = exports.fetchAllProductDepositTemplates = function fetchAllProductDepositTemplates(ProductId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var payload, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isNaN(ProductId)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", dispatch({
              type: RESET_DEPOSIT_INFO
            }));
          case 2:
            dispatch(fetchingDepositTemplates(ProductId));
            payload = {
              ProductId: ProductId,
              OMSId: getState().user.userInfo.OMSId,
              AccountId: getState().user.selectedAccountId
            };
            _context.next = 6;
            return dispatch((0, _apiActions.callAPI)('GetDepositTemplateTypes', payload))["catch"](function () {
              return dispatch(fetchProductDepositTemplate(ProductId));
            });
          case 6:
            data = _context.sent;
            _context.prev = 7;
            if (!data.result) {
              _context.next = 14;
              break;
            }
            if (!(data.TemplateTypes && !data.TemplateTypes.length)) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", dispatch(depositTemplatesError('There are no providers configured for this product')));
          case 11:
            dispatch(receiveDepositTemplates(data.TemplateTypes));
            if (data.TemplateTypes && data.TemplateTypes.length === 1) {
              dispatch(fetchProductDepositTemplate(ProductId, data.TemplateTypes[0].AccountProviderId));
            }
            return _context.abrupt("return", true);
          case 14:
            return _context.abrupt("return", dispatch(depositTemplatesError(data.errormsg)));
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](7);
            dispatch(fetchProductDepositTemplate(ProductId));
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 17]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var fetchProductDepositTemplate = exports.fetchProductDepositTemplate = function fetchProductDepositTemplate(ProductId, AccountProviderId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var payload, data, _data$Template, UseGetDepositWorkflow, Template, DepositWorkflow;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isNaN(ProductId)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", dispatch({
              type: RESET_DEPOSIT_INFO
            }));
          case 2:
            dispatch(fetchingDepositTemplate(ProductId, AccountProviderId));
            payload = {
              OMSId: getState().user.userInfo.OMSId,
              AccountId: getState().user.selectedAccountId,
              ProductId: ProductId,
              AccountProviderId: AccountProviderId
            };
            _context2.next = 6;
            return dispatch((0, _apiActions.callAPI)('GetDepositRequestInfoTemplate', payload));
          case 6:
            data = _context2.sent;
            if (!(data && data.result)) {
              _context2.next = 13;
              break;
            }
            _data$Template = data.Template, UseGetDepositWorkflow = _data$Template.UseGetDepositWorkflow, Template = _data$Template.Template, DepositWorkflow = _data$Template.DepositWorkflow;
            if (UseGetDepositWorkflow || DepositWorkflow === 'CryptoWallet') {
              dispatch(getDepositInfo(ProductId));
            } else {
              dispatch(depositInfoError('Failed to load'));
            }
            if (Template) {
              _context2.next = 12;
              break;
            }
            return _context2.abrupt("return", dispatch(depositTemplateError('Server provided an unexpected response')));
          case 12:
            return _context2.abrupt("return", dispatch(receiveDepositTemplate(data)));
          case 13:
            return _context2.abrupt("return", dispatch(depositTemplateError(data ? data.errormsg : 'Internal error')));
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getDepositInfo = exports.getDepositInfo = function getDepositInfo(ProductId, template, accountProviderId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var OMSId, AccountId, templateType, templateTypeObj, payload, depositInfo, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            templateType = getState().deposit.AccountProviderId;
            templateTypeObj = getState().deposit.templateTypes.find(function (template) {
              return template.AccountProviderId === templateType;
            });
            payload = {
              OMSId: OMSId,
              AccountId: AccountId,
              ProductId: +ProductId,
              GenerateNewKey: _config["default"].Deposit.generateNewKey
            };
            if (templateTypeObj) {
              payload.AccountProviderId = templateTypeObj.AccountProviderId;
            }
            if (accountProviderId) {
              payload.AccountProviderId = accountProviderId;
            }
            if (template) {
              payload.DepositInfo = template;
            }
            dispatch(fetchingDepositInfo(ProductId));
            _context3.next = 11;
            return dispatch((0, _apiActions.callAPI)('GetDepositInfo', payload));
          case 11:
            depositInfo = _context3.sent;
            if (!depositInfo.result) {
              _context3.next = 15;
              break;
            }
            try {
              data = JSON.parse(depositInfo.DepositInfo);
            } catch (e) {
              console.log(e);
              data = [depositInfo.DepositInfo];
            }
            return _context3.abrupt("return", dispatch(receiveDepositInfo(data)));
          case 15:
            return _context3.abrupt("return", dispatch(depositInfoError(depositInfo.errormsg)));
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var getDepositTickets = exports.getDepositTickets = function getDepositTickets() {
  var StartIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var OMSId, AccountId, depositTickets;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch(requestDepositTickets({
              StartIndex: StartIndex
            }));
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            _context4.next = 5;
            return dispatch((0, _apiActions.callAPI)('GetDepositTickets', {
              OMSId: OMSId,
              AccountId: AccountId,
              OperatorId: 1,
              StartIndex: StartIndex
            }));
          case 5:
            depositTickets = _context4.sent;
            return _context4.abrupt("return", dispatch(receiveDepositTickets(depositTickets)));
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var createDepositTicket = exports.createDepositTicket = function createDepositTicket(_ref5) {
  var ProductId = _ref5.ProductId,
    amount = _ref5.amount,
    info = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var OMSId, AccountId, UseGetDepositWorkflow, DepositInfo, AccountProviderId, payload, depositStatus;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            UseGetDepositWorkflow = getState().deposit.templateInfo.UseGetDepositWorkflow;
            DepositInfo = JSON.stringify(info);
            AccountProviderId = getState().deposit.AccountProviderId;
            payload = {
              OMSId: OMSId,
              OperatorId: 1,
              AccountId: AccountId,
              AccountProviderId: AccountProviderId,
              RequestUser: AccountId,
              AssetId: +ProductId,
              Amount: amount ? amount : +info.Amount,
              DepositInfo: DepositInfo,
              Status: 'New'
            };
            dispatch(submittingDeposit);
            if (!UseGetDepositWorkflow) {
              _context5.next = 9;
              break;
            }
            return _context5.abrupt("return", dispatch(getDepositInfo(ProductId, DepositInfo)));
          case 9:
            _context5.next = 11;
            return dispatch((0, _apiActions.callAPI)('CreateDepositTicket', payload));
          case 11:
            depositStatus = _context5.sent;
            if (!(depositStatus.result === false)) {
              _context5.next = 14;
              break;
            }
            return _context5.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'depositRejectSnack',
              text: (0, _errorTextFormatter.formatErrorText)(depositStatus),
              type: 'warning'
            })));
          case 14:
            dispatch((0, _sidePaneActions.closeDepositSidePane)());
            // t('Your deposit has been successfully added')
            dispatch(getDepositTickets());
            if (!_config["default"].Deposit.showDepositIdModal) {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'depositSuccessSnack',
                text: 'Your deposit has been successfully added',
                type: 'success'
              }));
            }
            return _context5.abrupt("return", dispatch(receiveDepositTicket(depositStatus)));
          case 18:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x9, _x10) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var subscribeToDeposits = exports.subscribeToDeposits = function subscribeToDeposits() {
  return function (dispatch) {
    _depositSubscriptionService["default"].subscribe(function (updates) {
      dispatch(addDeposit(updates));
    });
  };
};
var addDeposit = exports.addDeposit = function addDeposit(payload) {
  return {
    type: ADD_DEPOSIT,
    payload: payload
  };
};
var fetchingDepositTemplates = exports.fetchingDepositTemplates = function fetchingDepositTemplates(product) {
  return {
    type: FETCH_PRODUCT_DEPOSIT_TEMPLATES,
    payload: {
      product: product
    }
  };
};
var fetchingDepositTemplate = exports.fetchingDepositTemplate = function fetchingDepositTemplate(product, AccountProviderId) {
  return {
    type: FETCH_PRODUCT_DEPOSIT_TEMPLATE,
    payload: {
      product: product,
      AccountProviderId: AccountProviderId
    }
  };
};
var fetchingDepositInfo = exports.fetchingDepositInfo = function fetchingDepositInfo(product) {
  return {
    type: FETCH_DEPOSIT_INFO,
    payload: {
      product: product
    }
  };
};
var receiveDepositTemplates = exports.receiveDepositTemplates = function receiveDepositTemplates(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATES,
    payload: payload
  };
};
var requestDepositTickets = exports.requestDepositTickets = function requestDepositTickets(payload) {
  return {
    type: REQUEST_DEPOSIT_TICKETS,
    payload: payload
  };
};
var receiveDepositTemplate = exports.receiveDepositTemplate = function receiveDepositTemplate(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATE,
    payload: payload
  };
};
var depositTemplatesError = exports.depositTemplatesError = function depositTemplatesError(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATES_ERROR,
    payload: payload
  };
};
var depositTemplateError = exports.depositTemplateError = function depositTemplateError(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATE_ERROR,
    payload: payload
  };
};
var depositInfoError = exports.depositInfoError = function depositInfoError(payload) {
  return {
    type: RECEIVE_DEPOSIT_INFO_ERROR,
    payload: payload
  };
};
var submittingDeposit = exports.submittingDeposit = {
  type: SUBMITTING_DEPOSIT
};
var receiveDepositInfo = exports.receiveDepositInfo = function receiveDepositInfo(payload) {
  return {
    type: RECEIVE_DEPOSIT_INFO,
    payload: payload
  };
};
var receiveDepositTicket = exports.receiveDepositTicket = function receiveDepositTicket(payload) {
  return {
    type: RECEIVE_DEPOSIT_TICKET,
    payload: payload
  };
};
var receiveDepositTickets = exports.receiveDepositTickets = function receiveDepositTickets(payload) {
  return {
    type: RECEIVE_DEPOSIT_TICKETS,
    payload: payload
  };
};